import React from 'react';
import { ActionIcon } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import axios from 'axios';
import appStore from '@duck/app-store';

export default function LogoutButton() {
  const admin = appStore((state) => state.admin);
  const entryPoint = admin ? '/app/admin' : '/app/athlete';

  function onClick() {
    axios
      .post('/logout/')
      .then(() => (window.location = entryPoint))
      .catch(() => (window.location = entryPoint));
  }

  return (
    <ActionIcon variant="subtle" title="Logout" onClick={onClick}>
      <IconLogout size={14} />
    </ActionIcon>
  );
}
